import { useQuery } from '@tanstack/react-query';

import { myIppeCalculationMembersKey, requestMyIppeCalculationMembers } from './membersApi';

/**
 * The rows of the directory's IPPE Calculation view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myIppeCalculationMembers` is a pure read, so infrastructure errors
 * travel the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyIppeCalculationMembers() {
  return useQuery({ queryKey: myIppeCalculationMembersKey, queryFn: requestMyIppeCalculationMembers });
}
